
import Vue from 'vue';
import { mapState } from 'vuex';

export default Vue.extend({
	name: 'LogsPane',
	props: {
		showSbudAdminLog: { type: Boolean, default: false },
	},
	computed: {
		...mapState([
			'user',
			'toolbar',
			'isAdminProxyingUser',
		]),
		logViewerUrl () {
			const sbudSecret: string = this._get(this.toolbar, 'sbudServices.secrets.sbud') || null;
			const appName = this._get(this.toolbar, 'session.apps[0]', '');
			let targetApp = appName.replace(/-001$/, '');
			let authString = "";
			if (this.user.isAdmin || this.isAdminProxyingUser) {
				if (this.showSbudAdminLog) targetApp = "SBUD";
				if (sbudSecret) authString = `&authorization=${sbudSecret}`;
			}
			return `${this.toolbar.session.serverUrlSBUD}/log_view?app=${targetApp}${authString}`;
		},
	},
});
